var Utilities = /** @class */ (function () {
    function Utilities() {
    }
    /**
     * Prompts a user to confirm their action
     *
     * @param message What to ask to confirm
     */
    Utilities.confirm = function (message) {
        if (confirm(message)) {
            return Promise.resolve(true);
        }
        else {
            return Promise.reject(false);
        }
    };
    /**
     * Persist is_iframe param if present
     */
    Utilities.getIframeParam = function () {
        if (window.location.href.indexOf('is_iframe=true') !== -1) {
            return '?is_iframe=true';
        }
        return '';
    };
    /**
     * Apply modal-active class to body,html tags, used to
     * control scrolling during modal active state
     *
     * @param active
     */
    Utilities.toggleModalActiveClass = function (active) {
        if (active === void 0) { active = false; }
        if (active) {
            document.body.classList.add('modal-active');
            document.getElementsByTagName('html')[0].classList.add('modal-active');
            return;
        }
        document.body.classList.remove('modal-active');
        document.getElementsByTagName('html')[0].classList.remove('modal-active');
        return;
    };
    return Utilities;
}());
export { Utilities };
